import { render, staticRenderFns } from "./dsclf.vue?vue&type=template&id=4deacb7d&"
import script from "./dsclf.vue?vue&type=script&lang=js&"
export * from "./dsclf.vue?vue&type=script&lang=js&"
import style0 from "./dsclf.vue?vue&type=style&index=0&id=4deacb7d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports